// Set Validation Defaults
$.validator.setDefaults({
  debug: false,
  success: "valid",
  errorElement: "span",
  errorPlacement: function (error, element) {
    error.addClass("invalid-feedback");
    element.closest(".form-group").append(error);
  },
  highlight: function (element) {
    $(element).addClass("is-invalid");
  },
  unhighlight: function (element) {
    $(element).removeClass("is-invalid");
  }
});

// Custom validator for date formatting
$.validator.addMethod(
  "dateFormat",
  function (value) {
    return value.match(
      /^(?:(0[1-9]|1[012])[/.](0[1-9]|[12][0-9]|3[01])[/.](19|20)[0-9]{2})$/
    );
  },
  "Please enter a date in the format mm/dd/yyyy."
);

// Custom validator for contains at least one lower-case letter
$.validator.addMethod(
  "atLeastOneLowercaseLetter",
  function (value, element) {
    return this.optional(element) || /[a-z]+/.test(value);
  },
  "Must have at least one lowercase letter"
);

// Custom validator for contains at least one upper-case letter.
$.validator.addMethod(
  "atLeastOneUppercaseLetter",
  function (value, element) {
    return this.optional(element) || /[A-Z]+/.test(value);
  },
  "Must have at least one uppercase letter"
);

// Custom validator for contains at least one symbol.
$.validator.addMethod(
  "atLeastOneSymbol",
  function (value, element) {
    return this.optional(element) || /[!@#$%^&*()]+/.test(value);
  },
  "Must have at least one symbol"
);

// Custom Rule Status Checker
$.validator.prototype.ruleValidationStatus = function (element) {
  element = $(element)[0];
  var rules = $(element).rules();
  var errors = {};
  for (var method in rules) {
    var rule = {
      method: method,
      parameters: rules[method]
    };
    try {
      var result = $.validator.methods[method].call(this, element.value.replace(/\r/g, ""), element, rule.parameters);

      errors[rule.method] = result;

    } catch (e) {
      console.log(e);
    }
  }
  return errors;
}
